import { Value } from 'baseui/select';
import { HotelCheckInStatusEnum } from 'common/constants/enum';
import Separator from 'components/common/separator';
import Select from 'components/elements/master/select-input';
import Text from 'components/elements/text';
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { HotelScheduleFormType } from './hotel-schedule-form-type';

const name = 'hotelSchedules' as const;
export default function HotelScheduleStatusSelect() {
  const [selectValue, setSelectValue] = React.useState<Value>([
    {
      id: HotelCheckInStatusEnum.NotAvailable,
      label: 'Not Available',
    },
  ]);
  const { control, setValue } = useFormContext<HotelScheduleFormType>();

  const hotelSchedules = useWatch({
    name,
    control,
  });

  const hasChecked =
    hotelSchedules.length !== 0 &&
    hotelSchedules.some((schedule) => schedule.isCheck);

  return (
    <div
      style={{
        maxWidth: 160,
      }}
    >
      <Text variant="LabelSmall">Update Selected Status</Text>
      <Separator gap={6} />
      <Select
        disabled={!hasChecked}
        options={[
          {
            id: HotelCheckInStatusEnum.NotAvailable,
            label: 'Not Available',
          },
          {
            id: HotelCheckInStatusEnum.NotCheckedIn,
            label: 'Not Check In',
          },
          {
            id: HotelCheckInStatusEnum.CheckedIn,
            label: 'Check In',
          },
        ]}
        value={selectValue}
        clearable={false}
        onChange={(params) => {
          const details = hotelSchedules.map((schedule) => {
            return schedule.isCheck
              ? {
                  ...schedule,
                  checkInStatus: params?.option
                    ?.id as HotelCheckInStatusEnum | null,
                }
              : schedule;
          });
          setValue(name, details);
          setSelectValue(params.value);
        }}
      />
    </div>
  );
}
